import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { SelectionItem } from '../../../core/component/select/select.component';
import { HomepalDashboardMenuModel } from '../../model/homepal-dashboard-menu-model';

@Injectable()
export class HomepalService {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    // The homepal endpoint is ported to V2 (Modules/Homepal); the V1 base is retired locally.
    this._endpoint = config.apiEndpointV2;
  }

  private _endpoint: string;

  get(): Observable<HomepalDashboardMenuModel> {
    return this._client.get<any[]>(`${this._endpoint}/homepal`).pipe(
      map(res => new HomepalDashboardMenuModel(res)),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }
}
